'use client';
import type { DialogOverlayProps } from '@radix-ui/react-dialog';

import {
  Dialog,
  DialogCloseButton,
  DialogContent,
} from '@wwe-portal/ui/components/dialog';
import { cn } from '@wwe-portal/ui/lib/lib';

import type { OfferReviewProps } from './offer-review';
import { OfferReview } from './offer-review';

export interface OfferReviewDialogProps {
  onClose?: () => void;
  open?: boolean;
  data: OfferReviewProps;
  className?: string;
  overlayProps?: Omit<
    DialogOverlayProps & React.RefAttributes<HTMLDivElement>,
    'ref'
  >;
  isAggregate?: boolean;
  onItemClick?: (id: string) => void;
}
export function OfferReviewDialog({
  open,
  onClose,
  data,
  className,
  isAggregate,
  onItemClick,
  overlayProps,
}: Readonly<OfferReviewDialogProps>) {
  const isSingleContent =
    (data.items?.length ?? 0) + (data.rewardItems?.length ?? 0) === 1;

  return (
    <Dialog
      data-offer-id={data.id}
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose?.();
      }}
      open={open}
    >
      <DialogContent
        className={cn(
          'xs:w-[362px] bg-back200 z-dialog w-[316px] max-w-none select-none gap-0 pt-[22px] md:w-[410px]',
          {
            'xs:w-[316px] md:w-[410px]': isSingleContent,
          },
          className
        )}
        data-id="offer-review-dialog"
        overlayProps={overlayProps}
        variant="dialog"
      >
        <OfferReview
          {...data}
          disabled={false}
          isAggregate={isAggregate}
          isSingleContent={isSingleContent}
          onItemClick={onItemClick}
        />
        <DialogCloseButton onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
}
